var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationProvider", {
    ref: "provider",
    attrs: { name: "birthday", rules: _vm.validationRules, slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var errors = ref.errors
          var validate = ref.validate
          return [
            _c("div", { staticClass: "financeApplication__form" }, [
              _c(
                "div",
                { class: _vm.classNames },
                [
                  _c(
                    "FinanceApplicationRow",
                    {
                      attrs: {
                        id: "birthday",
                        label: "DOB",
                        "is-label-screen-reader-only": true,
                        "error-message": errors[0],
                      },
                    },
                    [
                      _c("FinanceApplicationText", {
                        attrs: {
                          id: "birthday",
                          placeholder: "DD/MM/YYYY",
                          name: "birthday",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.onChange($event, validate)
                          },
                        },
                        model: {
                          value: _vm.birthday,
                          callback: function ($$v) {
                            _vm.birthday = $$v
                          },
                          expression: "birthday",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "financeApplication__additionalText" }, [
                _vm._v(
                  "\n            You must be 18 or over to be eligible\n        "
                ),
              ]),
            ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }